<template>
  <ul class="user-menu">
    <ul :class="`burger ${burgerShow()}`">
      <li class="burger__item">
        <i class="material-icons md-24 burger__icon" @click="toggleBurger">{{getIcon}}</i>
      </li>
    </ul>

    <li class="user-menu__item">
      <i class="material-icons md-24">account_box</i>

      <ul class="user-sub-menu">
        <li class="user-sub-menu__item">
          <a class="user-sub-menu__link" @click.prevent="logOut">выход</a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { AUTH_LOGOUT } from "../../../../store/actions/auth";

export default {
  name: "UserMenu",
  props: {
    showSidebar: {
      type: Boolean
    }
  },
  data(){
    return {
      onRoute: '',
    }
  },
  computed: {
    getIcon() {
      return this.showSidebar ? 'close' : 'menu';
    },
  },
  methods: {
    burgerShow() {
      return this.onRoute !== 'threadId' ? 'burger--hide' : '';
    },
    toggleBurger() {
      this.$emit('onToggle');
    },
    logOut() {
      this.$store.dispatch(AUTH_LOGOUT);
    }
  },
  mounted() {
    this.onRoute = this.$route.name;
  },
  watch: {
    $route(route) {
      this.onRoute = route.name;
    },
  },
};
</script>

<style>
.user-menu {
  display: flex;
  margin: 0 11px 0 0;
  padding: 0;
  list-style: none;
  max-height: 24px;
}

.user-menu__item {
  position: relative;
  z-index: 7;
  cursor: pointer;
}

.user-menu__item:hover .user-sub-menu {
  display: block;
}

.user-sub-menu {
  display: none;
  position: absolute;
  bottom: -32px;
  left: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid #c4c4c4;
}

.user-sub-menu__item {
  padding: 3px 10px 5px 10px;
  background-color: #ffffff;
  box-shadow: 0 0 7px rgba(-5, 0, 0, 0.25);
  box-sizing: border-box;
}

.user-sub-menu__link {
  font-family: "Oswald", "Arial", sans-serif;
  font-weight: 300;
  color: #000000;
  font-size: 18px;
  line-height: normal;
  text-decoration: none;
}

.burger {
  display: none;
  padding: 0;
  margin: 0 15px 0 0;
  list-style: none;
}

.burger--hide {
  display: none;
}

.burger__item {
  cursor: pointer;
}

@media (max-width: 1040px) {
  .burger {
    display: flex;
  }

  .burger--hide {
    display: none;
  }
}

</style>
